import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'

import { BlueBox, NoResults } from '../common'
import { Padding, ProgressChart } from '../../../..'

const Header = styled.div`
    font-size: 15px;
    height: 20%;
`

const Body = styled.div`
  align-items: flex-end;
  display: flex;
  height: 80%;
  justify-content: space-between;
  width 100%;
`

const CustomerColleague = ({ isEmpty, loading, value, withLavels, t }) => (
    <BlueBox loading={loading} noResults={isEmpty}>
        <Header>
            <Padding fullHeight>{t('Customer vs. Colleague')}</Padding>
        </Header>
        <Body>
            {isEmpty && <NoResults />}
            {!isEmpty && <ProgressChart size="lg" value={value} labels={withLavels ? ['Customer', 'Colleague'] : null} withPercentage withOpponent />}
        </Body>
    </BlueBox>
)

CustomerColleague.propTypes = {
    isEmpty: PropTypes.bool,
    loading: PropTypes.number,
    value: PropTypes.number,
    withLavels: PropTypes.bool,
    t: PropTypes.func.isRequired,
}

CustomerColleague.defaultProps = {
    isEmpty: true,
    loading: null,
    value: 0,
    withLavels: true,
}

export default withTranslation()(CustomerColleague)
